export default "__VITE_ASSET__Dyhxd0_1__"